import { api } from "@/services/api";
import {
  AdminPromotion,
  CreatePromotion,
  PaginatedResponse,
  Promotion,
  UpdatePromotion,
} from "@/types";

export interface PromotionListParams {
  page: number;
  limit: number;
}

export class PromotionRepository {
  async findAll(
    params: PromotionListParams,
  ): Promise<PaginatedResponse<Promotion>> {
    const response = await api.get<PaginatedResponse<Promotion>>(
      "/v1/admin/promotions",
      { params },
    );

    return response.data;
  }

  async findById(id: string): Promise<AdminPromotion> {
    const response = await api.get<AdminPromotion>(
      `/v1/admin/promotions/${id}`,
    );

    return response.data;
  }

  async create(data: CreatePromotion): Promise<AdminPromotion> {
    const response = await api.post<AdminPromotion>(
      "/v1/admin/promotions",
      data,
    );

    return response.data;
  }

  async update(id: string, data: UpdatePromotion): Promise<AdminPromotion> {
    const response = await api.patch<AdminPromotion>(
      `/v1/admin/promotions/${id}`,
      data,
    );

    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/v1/admin/promotions/${id}`);
  }
}
